@if (useAccordionComponent) {
  <!--TODO: If still in use, add the File logic-->
  <mat-accordion>
    <mat-expansion-panel
      (opened)="panelOpenState.set(true)"
      (closed)="panelOpenState.set(false)"
      [expanded]="toggleAccordion"
      togglePosition="before"
      class="border-2">
      <mat-expansion-panel-header class="min-h-[100px] bg-brandLightBlueFill dark:bg-gray-700">
        <div class="flex flex-row justify-between items-center w-full">
          <div class="flex flex-col">
            <span class="font-bold text-xl dark:text-gray-200">{{ item?.quote_request_bond?.company_name }}</span>
            @if (item?.company_dba) {
              <span class="font-semibold text-md">DBA: {{ item?.company_dba }}</span>
            }
            <span class="font-medium text-sm text-gray-400 dark:text-gray-400">
              {{ item?.quote_request_bond?.state_abbreviation }} - {{ item?.quote_request_bond?.surety_bond_label }}
              @if (item?.selected_quote?.bond_effective_date) {
                | Effective Date: {{ item?.selected_quote?.bond_effective_date ?? '' | date: 'shortDate' }}
              }
            </span>
          </div>
          <div class="flex flex-col align-right text-right">
            <p class="text-lg font-bold" *ngIf="item?.selected_quote?.premium">
              {{ item?.selected_quote?.premium | currency: 'USD' }}
            </p>

            <p class="accent-green-500 text-sm text-primary" *ngIf="item?.selected_quote?.duration">
              {{ getDurationTerm(item) }}
            </p>
          </div>
        </div>
      </mat-expansion-panel-header>
      <div class="rounded-lg px-2">
        <div class="w-full flex flex-col justify-between pt-4">
          <!--Bond Details-->
          <div class="flex flex-row justify-between">
            <span class="font-semibold text-lg my-4">Bond Details</span>
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Bond Details Menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                *ngFor="let _item of menuItems"
                [disabled]="!_item.enabled"
                (click)="onMenuItemClick(_item)">
                <mat-icon *ngIf="_item.icon">{{ _item.icon }}</mat-icon>
                <span>{{ _item.label }}</span>
              </button>
            </mat-menu>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <!-- License Number -->
            <div>
              <p class="bond-details-displayed-label">Order Number</p>
              <p class="text-md font-semibold text-green-500">{{ item?.order_number }}</p>
            </div>

            <!-- Date Ordered -->
            <div>
              <p class="bond-details-displayed-label">Date Ordered</p>
              <p class="bond-details-displayed-value">{{ item?.quote_request_date | date: 'MM/dd/yyyy' }}</p>
            </div>

            <!-- Company Type -->
            <div>
              <p class="bond-details-displayed-label">Company Type</p>
              <p class="bond-details-displayed-value">{{ item?.quote_request_bond?.company_type_label }}</p>
            </div>

            <!-- Principal Address -->
            <div>
              <p class="bond-details-displayed-label">Principal Address</p>
              <p class="bond-details-displayed-value">{{ getFormattedAddress(item?.principal_address) }}</p>
            </div>
          </div>
          <mat-divider class="my-4"></mat-divider>

          <!--Bond Owner-->
          <span class="font-semibold text-lg my-4">Bond Owner</span>
          <div class="grid grid-cols-2 gap-4">
            <!-- License Number -->
            <div>
              <p class="bond-details-displayed-label">Owner</p>
              <p class="text-md font-semibold">{{ item?.user_first_name + ' ' + item?.user_last_name }}</p>
            </div>

            <div>
              <p class="bond-details-displayed-label">Contact</p>
              <p class="bond-details-displayed-value">{{ formatPhone(item.user_phone) }}</p>
            </div>
          </div>
          <mat-divider class="my-4"></mat-divider>

          <!-- Communications -->
          <ng-container *ngIf="activeCommunicationContacts().length > 0">
            <span class="font-semibold text-lg my-4">Contacts</span>
            <div class="grid grid-cols-1 gap-2">
              @for (c of activeCommunicationContacts(); track c.user_id) {
                <div class="flex flex-col p-2 rounded border">
                  <div class="flex-1">
                    <div class="font-semibold">{{ c.name }}</div>
                    <div class="text-sm text-gray-600" *ngIf="c.company">{{ c.company }}</div>
                    <div class="text-sm text-gray-600" *ngIf="c.email && !isServiceEmail(c.email)">{{ c.email }}</div>
                    <div class="text-sm text-gray-600" *ngIf="c.phone">{{ formatPhone(c.phone) }}</div>
                  </div>
                  <div class="flex flex-col items-end gap-2">
                    @if (
                      !isMissingEmail(c.email) &&
                      currentAccountUser().email !== c.email &&
                      (+item.customer_can_purchase === 1 || isOverdue())
                    ) {
                      <cipx-primary-button
                        variant="stroked"
                        icon="email"
                        iconPosition="prepend"
                        class="btn-sm text-xs h-8"
                        (buttonClick)="openSendReminderDialog(c)">
                        Send Reminder
                      </cipx-primary-button>
                    }
                  </div>
                </div>
              }
            </div>
            <mat-divider class="my-4"></mat-divider>
          </ng-container>
          @if (item?.selected_quote) {
            <!--Quote Options-->
            <span class="font-semibold text-lg my-4">Quote Options</span>
            <div class="border-1 rounded-lg border-gray-600 overflow-hidden">
              @if (item?.customer_can_purchase === 1) {
                <form [formGroup]="item?.quote_selection_form">
                  <!--Bond Option Selector-->
                  <mat-radio-group
                    aria-label="Select Bond Term"
                    class="flex flex-col w-full rounded-lg"
                    formControlName="selected_quote_option"
                    (change)="setSelectedQuoteOption()">
                    <div class="flex flex-col gap-0 m-1">
                      <div
                        *ngFor="let quoteOption of item?.quote_request_bond.quotes"
                        [ngClass]="{ 'border-2': quoteOption.premium !== item?.selected_quote?.premium }">
                        <div
                          class="flex flex-row w-full rounded-md dark:text-gray-200"
                          [ngClass]="{
                            'selected border-2 border-brandOrange bg-orange-50 dark:bg-brandOrange':
                              quoteOption.premium === item?.selected_quote?.premium,
                            '': +item?.customer_can_purchase !== 0,
                          }">
                          <mat-radio-button [value]="quoteOption.premium" class="pt-1 w-[30px]"></mat-radio-button>
                          <div class="flex flex-col w-full p-3">
                            <div class="flex flex-row justify-between text-md font-semibold">
                              <span>{{ getDurationTerm(quoteOption) }}</span>
                              <div class="flex flex-col justify-end items-end">
                                <span>{{ quoteOption?.premium | currency: 'USD' }}</span>
                                <!--                              <span *ngIf="+item?.customer_can_purchase === 0 && quoteOption.premium === item?.selected_quote?.premium" class="badge badge-brandGreen">Selected</span>-->
                              </div>
                            </div>
                            <div class="flex flex-row justify-between text-sm text-gray-400 dark:text-gray-200">
                              <span>
                                {{ quoteOption?.bond_effective_date ?? '' | date: 'shortDate' }}&nbsp;-&nbsp;{{
                                  quoteOption?.bond_expiration_date | date: 'shortDate'
                                }}
                              </span>
                              @if (
                                quoteOption?.collateral !== null &&
                                !isNaN(+quoteOption?.collateral) &&
                                +quoteOption?.collateral > 0
                              ) {
                                <span class="text-red-500 dark:text-black text-sm">
                                  Requires Collateral: {{ quoteOption?.collateral | currency: 'USD' }}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-radio-group>
                </form>
              } @else {
                <div class="flex flex-col gap-0 m-1">
                  <div
                    class="flex flex-row w-full rounded-md dark:text-gray-200 selected border-2 border-brandOrange bg-orange-50 dark:bg-brandOrange">
                    <mat-radio-button [checked]="true" class="pt-1 w-[30px]" [disabled]="true"></mat-radio-button>
                    <div class="flex flex-col w-full p-3">
                      <div class="flex flex-row justify-between text-md font-semibold">
                        <span>{{ getDurationTerm(item?.selected_quote) }}</span>
                        <div class="flex flex-col justify-end items-end">
                          <span>{{ item?.selected_quote?.premium | currency: 'USD' }}</span>
                        </div>
                      </div>
                      <div class="flex flex-row justify-between text-sm text-gray-400 dark:text-gray-200">
                        <span>
                          {{ item?.selected_quote?.bond_effective_date ?? '' | date: 'shortDate' }}&nbsp;-&nbsp;{{
                            item?.selected_quote?.bond_expiration_date | date: 'shortDate'
                          }}
                        </span>
                        @if (
                          item?.selected_quote?.collateral !== null &&
                          !isNaN(+item?.selected_quote?.collateral) &&
                          +item?.selected_quote?.collateral > 0
                        ) {
                          <span class="text-red-500 dark:text-black text-sm">
                            Requires Collateral: {{ item?.selected_quote?.collateral | currency: 'USD' }}
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }

          <!--Bond Delivery-->
          <div class="my-4">
            <span class="font-semibold text-lg">Bond Delivery</span>
            <p class="text-sm text-gray-400 dark:text-gray-200">Delivery Method</p>
            <span class="bg-orange-300 dark:bg-brandOrange dark:text-gray-200 px-4 py-1 rounded-md w-fit">
              {{ item?.shipping_details?.shipping_option_label }}
            </span>
          </div>
          <!--Bond Delivery-->
          <div class="my-4" *ngIf="item?.quote_request_bond?.related_files.length > 0">
            <span class="font-semibold text-lg my-4">
              Attached File{{
                item?.quote_request_bond.related_files.length > 1
                  ? 's (' + item?.quote_request_bond.related_files.length + ')'
                  : ''
              }}
            </span>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div
                *ngFor="let file of item?.quote_request_bond?.related_files"
                (click)="getFile(item?.quote_request_id, file.file_id)"
                class="p-4 border rounded cursor-pointer hover:bg-gray-50 flex items-center gap-3"
                [title]="file.file_friendly_name">
                <mat-icon class="text-gray-600">
                  {{ getFileIcon(file.file_extension) }}
                </mat-icon>

                <div class="flex-1 min-w-0">
                  <div class="font-medium text-sm">
                    {{ file.file_purpose_label }}
                  </div>
                  <div class="text-gray-600 truncate">
                    {{ file.file_friendly_name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
} @else if (fullDisplayWithoutAccordion) {
  <div class="cipx-form-container w-full">
    <cipx-scrollable-content [noPadding]="true" class="px-2">
      <div class="rounded-lg">
        <div class="w-full flex flex-col justify-between pt-0 mb-[50px]">
          @if (item?.is_managed === false) {
            <div class="alert alert-warning my-2">
              <div class="alert-title">Unmanaged {{ item?.issue_date !== null ? 'Bond' : 'Request' }}</div>
              <div class="alert-message">
                {{ item?.issue_date !== null ? 'This Bond' : 'This request for a quote' }} is associated with your
                account, but the customer did not authorize your account to manage the request or take actions. For the
                customer’s privacy, no details are shown.
                @if (isAgency()) {
                  <p>You will still receive your standard commission if the bond is sold.</p>
                }
              </div>
            </div>
            <mat-divider class="bond-details-mat-divider"></mat-divider>
          }

          <!--Bond Details-->
          <div class="flex flex-col">
            <div class="flex flex-row justify-between items-center">
              <span class="bond-details-group-title">Bond Details</span>
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="More Options">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  *ngFor="let item of menuItems"
                  [disabled]="!item.enabled"
                  (click)="onMenuItemClick(item)">
                  <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
                  <span>{{ item.label }}</span>
                </button>
              </mat-menu>
            </div>

            <div class="bond-details-group-content">
              <div class="bond-details-bond-label">
                {{ item.quote_request_bond.bond_amount | currency: 'USD' }}
                {{ item.quote_request_bond.state_abbreviation }} {{ item.quote_request_bond.surety_bond_label }}
              </div>
              <div class="bond-details-grid">
                <!-- Order Number -->
                <div>
                  <p class="bond-details-displayed-label">Order #</p>
                  <p class="bond-details-displayed-value">
                    @if (item?.is_managed === false && !item?.order_number) {
                      ******
                    } @else {
                      {{ item?.order_number }}
                      <span *ngIf="item.renewal_quote_request_id > 0" class="bg-renewal" matTooltip="Renewal">R</span>
                    }
                  </p>
                </div>

                <!--Reference Number-->
                <div>
                  <p class="bond-details-displayed-label">Bond #</p>
                  <p class="bond-details-displayed-value">
                    @if (item?.is_managed === false && !item?.selected_quote?.carrier_reference_number) {
                      ******
                    } @else {
                      {{ item?.selected_quote?.carrier_reference_number }}
                    }
                  </p>
                </div>
                <!--Effective Date-->
                <div>
                  <p class="bond-details-displayed-label">Effective Date</p>
                  <p class="bond-details-displayed-value">
                    @if (item?.is_managed === false && !item?.selected_quote?.bond_effective_date) {
                      ******
                    } @else {
                      {{ item?.selected_quote?.bond_effective_date | date: 'shortDate' }}
                    }
                  </p>
                </div>

                <!--Surety-->
                <div *ngIf="item?.quote_status_stage?.toLowerCase() === 'issued'">
                  <p class="bond-details-displayed-label">Surety</p>
                  <p class="bond-details-displayed-value">
                    @if (item?.is_managed === false && !item?.selected_quote?.writing_company_label) {
                      ******
                    } @else {
                      {{ item?.selected_quote?.writing_company_label }}
                    }
                  </p>
                </div>

                @if (item?.customer_status_label && showStatus) {
                  <div>
                    <p class="bond-details-displayed-label">Status</p>
                    <p class="bond-details-displayed-value">{{ item?.customer_status_label }}</p>
                  </div>
                }
              </div>
            </div>
          </div>

          <mat-divider class="bond-details-mat-divider"></mat-divider>
          <div class="flex flex-col">
            <span class="bond-details-group-title">Customer</span>
            <div class="bond-details-group-content">
              <div class="bond-details-grid">
                <div>
                  <div class="bond-details-bond-label">
                    @if (item?.is_managed === false && (!item?.user_first_name || !item?.user_last_name)) {
                      ******
                    } @else {
                      {{ (item?.user_first_name || '') + ' ' + (item?.user_last_name || '') }}
                    }
                  </div>

                  @if (item?.is_managed === false) {
                    <p class="bond-details-displayed-value">******</p>
                  } @else {
                    @if (!isMissingEmail(item.user_email_address)) {
                      <p class="bond-details-displayed-value">
                        {{ item.user_email_address }}
                      </p>
                    }
                  }
                  <p class="bond-details-displayed-value">
                    @if (item?.is_managed === false && !item?.user_phone) {
                      ******
                    } @else {
                      {{ formatPhone(item?.user_phone) }}
                    }
                  </p>
                </div>
              </div>
            </div>
          </div>
          <mat-divider class="bond-details-mat-divider"></mat-divider>
          <div class="flex flex-col">
            <span class="bond-details-group-title">Principal</span>
            <div class="bond-details-group-content">
              <div class="bond-details-grid">
                <div>
                  <div class="bond-details-bond-label">
                    @if (item?.is_managed === false && !item?.quote_request_bond?.company_name) {
                      ******
                    } @else {
                      {{ item?.quote_request_bond?.company_name }}
                    }
                  </div>
                  <p class="bond-details-displayed-value">
                    @if (item?.is_managed === false && !getFormattedAddress(item?.principal_address)) {
                      ******
                    } @else {
                      {{ getFormattedAddress(item?.principal_address) }}
                    }
                  </p>
                </div>

                <!-- Company Type -->
                <div>
                  <p class="bond-details-displayed-label mt-3">Company Type</p>
                  <p class="bond-details-displayed-value">
                    @if (item?.is_managed === false && !item?.quote_request_bond?.company_type_label) {
                      ******
                    } @else {
                      {{ item?.quote_request_bond?.company_type_label }}
                    }
                  </p>
                </div>
              </div>
            </div>
          </div>
          <mat-divider class="bond-details-mat-divider"></mat-divider>
          <div class="flex flex-col">
            <span class="bond-details-group-title">Owners / Indemnitors</span>
            <div class="bond-details-group-content">
              <div class="bond-details-grid">
                @if (item?.is_managed !== false) {
                  @for (owner of item?.owners; track $index) {
                    <div>
                      <div class="bond-details-bond-label">
                        {{ owner.name }}
                      </div>
                      <p class="bond-details-displayed-value break-words">
                        {{ getFormattedAddress(owner?.address) }}
                      </p>
                      @if (!isServiceEmail(owner.email)) {
                        <p class="bond-details-displayed-value break-words">
                          {{ owner.email }}
                        </p>
                      }
                    </div>
                  }
                } @else {
                  <div>
                    <div class="bond-details-bond-label">******</div>
                    <p class="bond-details-displayed-value">******</p>
                    <p class="bond-details-displayed-value">******</p>
                  </div>
                }
              </div>
            </div>
          </div>
          <mat-divider class="bond-details-mat-divider"></mat-divider>
          <div class="flex flex-col">
            <span class="bond-details-group-title">Quote</span>
            <div class="bond-details-group-content">
              <div class="bond-details-quote-grid">
                <div>
                  <p class="bond-details-displayed-label">Requested</p>
                  <p class="bond-details-displayed-value">{{ item?.quote_request_date | date: 'M/d/y' }}</p>
                </div>
                @if (item?.purchase_date) {
                  <div>
                    <p class="bond-details-displayed-label">Purchased</p>
                    <p class="bond-details-displayed-value">{{ item?.purchase_date | date: 'M/d/y' }}</p>
                  </div>
                }
                @if (item?.issue_date) {
                  <div>
                    <p class="bond-details-displayed-label">Issued</p>
                    <p class="bond-details-displayed-value">{{ item?.issue_date | date: 'M/d/y' }}</p>
                  </div>
                }

                <div>
                  <p class="bond-details-displayed-label">Premium</p>
                  @if (item?.is_managed === false && !item?.total_cost) {
                    <p class="bond-details-displayed-value">******</p>
                  } @else {
                    <p class="bond-details-displayed-value">{{ item?.total_cost | currency: 'USD' }}</p>
                  }
                </div>

                <div>
                  <p class="bond-details-displayed-label">Term</p>
                  @if (item?.is_managed === false && !item?.selected_quote) {
                    <p class="bond-details-displayed-value">******</p>
                  } @else {
                    <p class="bond-details-displayed-value">
                      {{ (item?.selected_quote?.duration || '') + ' ' + (item?.selected_quote?.duration_units || '') }}
                    </p>
                  }
                </div>

                <div>
                  <p class="bond-details-displayed-label">Sent Via</p>
                  @if (item?.is_managed === false && !item?.shipping_details?.shipping_option_label) {
                    <p class="bond-details-displayed-value">******</p>
                  } @else {
                    <p class="bond-details-displayed-value">{{ item?.shipping_details?.shipping_option_label }}</p>
                  }
                </div>
              </div>
            </div>
          </div>
          @if (item?.riders && item?.riders.length > 0) {
            <mat-divider class="bond-details-mat-divider"></mat-divider>
            <div class="flex flex-col">
              <span class="bond-details-group-title">Riders</span>
              <div class="bond-details-group-content overflow-x-auto">
                <table mat-table [dataSource]="item.riders" class="w-full">
                  <ng-container matColumnDef="reference">
                    <th mat-header-cell *matHeaderCellDef class="text-sm font-medium text-gray-500">Reference #</th>
                    <td mat-cell *matCellDef="let rider" class="text-sm">{{ rider.reference_number }}</td>
                  </ng-container>

                  <ng-container matColumnDef="label">
                    <th mat-header-cell *matHeaderCellDef class="text-sm font-medium text-gray-500">Type</th>
                    <td mat-cell *matCellDef="let rider" class="text-sm">{{ rider.bond_rider_label }}</td>
                  </ng-container>

                  <ng-container matColumnDef="requestDate">
                    <th mat-header-cell *matHeaderCellDef class="text-sm font-medium text-gray-500">Request Date</th>
                    <td mat-cell *matCellDef="let rider" class="text-sm">
                      {{ rider.bond_rider_request_date | date: 'shortDate' }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="effectiveDate">
                    <th mat-header-cell *matHeaderCellDef class="text-sm font-medium text-gray-500">Effective Date</th>
                    <td mat-cell *matCellDef="let rider" class="text-sm">
                      {{ rider.bond_rider_effective_date | date: 'shortDate' }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="issueDate">
                    <th mat-header-cell *matHeaderCellDef class="text-sm font-medium text-gray-500">Issue Date</th>
                    <td mat-cell *matCellDef="let rider" class="text-sm">
                      {{ rider.bond_rider_issue_date | date: 'shortDate' }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="['reference', 'label', 'requestDate', 'effectiveDate', 'issueDate']"></tr>
                  <tr
                    mat-row
                    *matRowDef="
                      let row;
                      columns: ['reference', 'label', 'requestDate', 'effectiveDate', 'issueDate']
                    "></tr>
                </table>
              </div>
            </div>
          }
          @if (fromInterface !== 'bonds') {
            <mat-divider class="bond-details-mat-divider"></mat-divider>
            <!-- Communications -->

            <div class="flex flex-col">
              <span class="bond-details-group-title">Communications Go To</span>
              <div class="bond-details-group-content">
                @if (activeCommunicationContacts().length === 0) {
                  <div class="text-sm text-gray-500">No active contacts</div>
                } @else {
                  <div class="flex flex-col gap-2">
                    @for (c of activeCommunicationContacts(); track c.user_id) {
                      @if (c.hasContactInfo) {
                        <div class="flex flex-col p-2 rounded border">
                          <div class="flex-1">
                            <div class="w-full flex flex-row justify-between">
                              <div class="font-semibold">{{ c.name }}</div>
                              @if (
                                !isMissingEmail(c.email) &&
                                currentAccountUser().email !== c.email &&
                                (+item.customer_can_purchase === 1 || isOverdue())
                              ) {
                                <a
                                  [matTooltip]="'Send a reminder'"
                                  class="cursor-pointer flex flex-row items-center justify-between gap-2 text-primary text-[10px] border-2 px-2 border-primary rounded-lg"
                                  (click)="openSendReminderDialog(c)">
                                  Send Reminder
                                </a>
                              }
                            </div>
                            @if (c.company) {
                              <div class="text-sm text-gray-600">{{ c.company }}</div>
                            }
                            @if (c.email && !isServiceEmail(c.email)) {
                              <div class="text-sm text-gray-600">{{ c.email }}</div>
                            }
                            @if (c.phone) {
                              <div class="text-sm text-gray-600">{{ formatPhone(c.phone) }}</div>
                            }
                          </div>
                        </div>
                      } @else {
                        <div class="flex flex-col p-2 rounded border">
                          <div class="flex-1">
                            <div class="font-semibold">{{ c.name }}</div>
                            <div class="text-sm text-gray-500">
                              {{ c.name }} was requested to receive communications, but no contact information is
                              available. Please reach out to your surety team if you would like to make updates.
                            </div>
                          </div>
                        </div>
                      }
                    }
                  </div>
                }
              </div>
            </div>
          }

          @if (item?.quote_request_bond?.related_files?.length > 0) {
            <mat-divider class="bond-details-mat-divider"></mat-divider>
            <div class="flex flex-col">
              <span class="bond-details-group-title">
                Attached File{{
                  item?.quote_request_bond.related_files.length > 1
                    ? 's (' + item?.quote_request_bond.related_files.length + ')'
                    : ''
                }}
              </span>
              <div class="bond-details-files-grid">
                <div
                  *ngFor="let file of item?.quote_request_bond?.related_files"
                  (click)="getFile(item?.quote_request_id, file.file_id)"
                  class="bond-details-file-container"
                  [title]="file.file_friendly_name">
                  <mat-icon class="bond-details-file-icon">
                    {{ getFileIcon(file.file_extension) }}
                  </mat-icon>
                  <div class="bond-details-file-labels-container">
                    <div class="bond-details-file-purpose-label">
                      {{ file.file_purpose_label }}
                    </div>
                    <div class="bond-details-file-friendly-name">
                      {{ file.file_friendly_name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (item?.payments?.length > 0) {
            <mat-divider class="bond-details-mat-divider"></mat-divider>
            <div class="flex flex-col">
              <span class="bond-details-group-title">Payments</span>
              <table mat-table [dataSource]="item?.payments" class="w-full">
                <ng-container matColumnDef="payment_id">
                  <th mat-header-cell *matHeaderCellDef class="text-sm font-medium text-gray-500">Payment #</th>
                  <td mat-cell *matCellDef="let payment" class="text-sm">
                    <div class="flex items-center gap-1">
                      {{ payment.payment_id }}
                      @if (payment?.concerned_order_numbers?.length > 1) {
                        <mat-icon
                          class="text-gray-400 text-[18px] w-[18px] h-[18px] flex items-center justify-center cursor-default"
                          [matTooltip]="
                            'Total payment of ' +
                            (payment?.payment_amount | currency: 'USD') +
                            ' was applied to ' +
                            payment?.concerned_order_numbers?.length +
                            ' orders.'
                          ">
                          info
                        </mat-icon>
                      }
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="payment_date">
                  <th mat-header-cell *matHeaderCellDef class="text-sm font-medium text-gray-500">Payment Date</th>
                  <td mat-cell *matCellDef="let payment" class="text-sm">
                    {{ payment.payment_date | date: 'shortDate' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="payment_status_label_dani">
                  <th mat-header-cell *matHeaderCellDef class="text-sm font-medium text-gray-500">Payment Status</th>
                  <td mat-cell *matCellDef="let payment" class="text-sm">{{ payment.payment_status_label_dani }}</td>
                </ng-container>

                <ng-container matColumnDef="payment_amount">
                  <th mat-header-cell *matHeaderCellDef class="text-sm font-medium text-gray-500 text-right">
                    Payment Amount
                  </th>
                  <td mat-cell *matCellDef="let payment" class="text-sm text-right">
                    {{ getPaymentAmountForCurrentOrder(payment) | currency: 'USD' }}
                  </td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="['payment_id', 'payment_date', 'payment_status_label_dani', 'payment_amount']"></tr>
                <tr
                  mat-row
                  *matRowDef="
                    let row;
                    columns: ['payment_id', 'payment_date', 'payment_status_label_dani', 'payment_amount']
                  "></tr>
              </table>
            </div>
          }
          @if (item?.quote_status_stage === 'Selling') {
            <mat-divider class="bond-details-mat-divider"></mat-divider>
            <button class="mt-2 m-auto w-1/3" mat-flat-button [color]="'primary'" (click)="buyNow(item)">
              Buy Now
            </button>
          }
        </div>
      </div>
    </cipx-scrollable-content>
  </div>
} @else {
  <div class="px-4 py-2 rounded-lg border-2 min-h-[100px] bg-brandLightBlueFill dark:bg-gray-700">
    @if (showSelectedDeliveryOption) {
      <div class="w-full">
        <span class="bg-primary text-black dark:text-gray-400 text-xs px-2 py-1 rounded">
          {{ item?.shipping_option_label }}
        </span>
      </div>
    }
    <div class="flex flex-row justify-between items-center ww-full">
      <div class="flex flex-col">
        <span class="font-bold text-xl dark:text-brandBlue">{{ item?.quote_request_bond?.company_name }}</span>
        @if (item?.company_dba) {
          <span class="font-semibold text-md">DBA: {{ item?.company_dba }}</span>
        }
        <span class="font-medium text-sm text-gray-400 dark:text-gray-200">
          {{ item?.quote_request_bond?.state_abbreviation }} - {{ item?.quote_request_bond?.surety_bond_label }}
          @if (item?.selected_quote?.bond_effective_date) {
            | Effective Date: {{ item?.selected_quote?.bond_effective_date ?? '' | date: 'shortDate' }}
          }
        </span>
      </div>
      <div class="flex flex-col align-right text-right">
        <p class="text-lg font-bold" *ngIf="item?.selected_quote?.premium">
          {{ item?.selected_quote?.premium | currency: 'USD' }}
        </p>

        <p class="accent-green-500 text-sm text-primary" *ngIf="item?.selected_quote?.duration">
          {{ getDurationTerm(item) }}
        </p>
      </div>
    </div>
  </div>
}
